import { ChangeDetectorRef, Component, inject, ViewChild } from '@angular/core';
import { TableComponent } from '../../../components/table/table.component';
import { MatExpansionPanel } from '@angular/material/expansion';
import { FilterBenefitCatalog } from '../../../models/filters/filter-benefit-catalog';
import { BenefitCatalogService } from '../../../services/benefit-catalog.service';
import { Router } from '@angular/router';
import { AlertaService } from '../../../services/alerta.service';
import { tableModel } from '../../../components/table/model/tableModel';

@Component({
  selector: 'app-benefits-catalog',
  standalone: false,
  templateUrl: './benefits-catalog.component.html',
  styleUrl: './benefits-catalog.component.css'
})
export class BenefitsCatalogComponent {


  @ViewChild(TableComponent) benefitsCatalogTable:TableComponent| undefined;
  @ViewChild('advancedPanel') advancedPanel!: MatExpansionPanel;

  tableModel: tableModel= {
    columnModel:[
      {columnName:'#',columnValue:'id'},
      {columnName:'Descripción',columnValue:'description'},
      {columnName:'Codigo',columnValue:'attribute'},
      {columnName:'Tipo Beneficio',columnValue:'benefitTypeDes'}
    ],
    dataSource:[],
    editButton:true
  };

  pageIndex: number = 1;
  pageSize: number = 5;
  loading: boolean = false;
  filterBenefitCatalog: FilterBenefitCatalog = new FilterBenefitCatalog;
  advancedSearch: boolean = false;
  
  private benefitCatalogService = inject(BenefitCatalogService);
  router = inject(Router);
  private cdr = inject(ChangeDetectorRef);
  private alerta = inject(AlertaService);

  ngOnInit(): void {
    this.filterBenefitCatalog = new FilterBenefitCatalog();
    this.searchBenefitGroupPaginator();
  }
  paginatorEvent(event: any){
    this.pageIndex = (event.pageIndex+1);
    this.pageSize = event.pageSize;
    this.searchBenefitGroupPaginator();
  }

  editEvent(event: any){
    this.router.navigate(['/benefitsCatalog/edit', event.id]);
  }
  addNewBenefitGroup(){
    this.router.navigate(['/benefitsCatalog/edit', 0]);
  }

  searchBenefitGroupPaginatorAS(){
    this.pageIndex = 1;
    this.advancedSearch = true;
    this.searchBenefitGroupPaginator();
  }

  searchBenefitGroupPaginator(){
    this.loading = true;

    this.benefitCatalogService.findAllPageableBenefitCatalog(this.filterBenefitCatalog, this.pageIndex, this.pageSize).subscribe({
      next: (pageable) => {
        this.tableModel.pageSize = pageable.pageSize;
        this.tableModel.totalRecords = pageable.itemsCount;
        this.tableModel.dataSource = pageable.list;
        this.tableModel.pageNumber = pageable.pageNum;
        
        setTimeout(() => {
          this.benefitsCatalogTable?.refresh(pageable.list, pageable.itemsCount);
        });
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.loading = false;
        if(err.status == 400){
          this.alerta.error("Se ha terminado el tiempo de session: ", {detail: err.message});
          this.router.navigate(['/login']);
        }else{
          this.alerta.error("Se ha precentado un error interno: ", {detail: err.message});
        }
      }
    });

    if(this.advancedPanel != null){
      if (this.advancedSearch) {
        this.advancedPanel.open();
      } else {
        this.advancedPanel.close();
      }
    }
  }
  
}
